import API from "@/services/api";

export default{
    getSchoolLocations(){
        return API().get(`school-location`);
    },
    getSchoolLocationsSRC(id){
        return API().get(`school-location/src/${id}`);
    },
    updateSchoolLocation(params){
        return API().put(`school-location`,params);
    }
}